import { html } from "lit-html";

export default data => html``;
